module.exports = __webpack_public_path__ + "static/img/logo.3e981f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/logo.png
// module id = wItz
// module chunks = 126